module.exports = __webpack_public_path__ + "static/media/a.0b66ed59.jpg";